import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.143 21.5a.952.952 0 1 0 0-1.905.952.952 0 0 0 0 1.905ZM19.619 21.5a.952.952 0 1 0 0-1.905.952.952 0 0 0 0 1.905ZM1.524 1.5h3.81l2.552 12.752a1.904 1.904 0 0 0 1.904 1.534h9.258a1.904 1.904 0 0 0 1.904-1.534l1.524-7.99H6.286"
    />
  </svg>
);
export { SvgComponent as ShoppingCart };
